// Builds a type guard that narrows a value to the Set's element type when
// the Set contains it.
export function inSet<T>(set: ReadonlySet<T>): (value: unknown) => value is T {
    return (value): value is T => set.has(value as T);
}
